import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect, useHistory, withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import Moment from "react-moment";
import Header from "../../layout/header/Header";
import { log } from "../../../utils";
import queryString from "query-string";
import { showLoading } from "../../../actions/action_loading";
import { showError } from "../../../actions/action_error_alert";
import GochiService from "../../../api/services/GochiService";
import { Button, Modal } from "react-bootstrap";
import GochiKidUseConfirmModal from "./GochiKidUseConfirmModal";
import PopupErrorV2 from "../PopupErrorV2";
import { MENU_USAGE_TYPE, SCAN_CODE_TYPE, TAX_RATE } from "../../../constants";
import Barcode from "../Barcode";
import GochiKidUseReceiptConfirmModal from "./GochiKidUseReceiptConfirmModal";
import QRCode from "qrcode.react";
import GochiKidUseGroupTimeErrorModal from "./GochiKidUseGroupTimeErrorModal";
const NO_IMAGE = require("../../../assets/img/icons/gochi_logo_print.png");

class GochiKidUse extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showGochiUseConfirm: false,
      dataInfo: {},
      quantity: 1,
      menuId: null,
      gochiUserId: null,
      shopId: null,
      useAmount: null,
      totalUseAmount: null,
      crfsToken: "",
      locationKeys: [],
      userInfo: queryString.parse(window.location.search).accessToken ? {isGuest: false, isLogined: true, userId: JSON.parse(atob(queryString.parse(window.location.search).accessToken.split(".")[1])).uid} : (this.props.userInfo ? this.props.userInfo : JSON.parse(localStorage.getItem('userInfo'))),
      isLoggedIn: this.props.userInfo?.userId ? true : false,
      isAccess: false,
      isFinished: false,
      listSponsor: {},
      usedAt: '',
      userKidIds: [],
      accessToken: queryString.parse(window.location.search).accessToken,
      gochiKidGroupId: queryString.parse(window.location.search).gochiKidGroupId,
      gochiKidUseCode: queryString.parse(window.location.search).gochiKidUseCode ? parseInt(queryString.parse(window.location.search).gochiKidUseCode) : 0,
      gochiKidUserLimit: queryString.parse(window.location.search).gochiKidUserLimit ? parseInt(queryString.parse(window.location.search).gochiKidUserLimit) : 0,
      shopNameInFinish: '',
      menuNameInFinish: '',
      includedTaxPriceInFinish: '',
      numberUseInFinish: '',
      flowQrUserGochiKidPopupFinish: false,
      shopIdInFinish: '',
      imageLogoInFinish: null,
      scanCodeInFinish: null,
      scanCodeTypeInFinish: null,
      codeGochiKidInFinish: null,
      keyGochiKidInFinish: null,
      mosburgerImageInFinish: null,
      gochiKidTwoocaInFinish: null,
      isShowError: false,
      titleError: '',
      contentError: '',
      textBtnError: '',
      urlError: '',
      taxRate: TAX_RATE.TAX_RATE_10_PERCENT,
      showGochiKidReceiptModal: false,
      showGroupTimeErrorModal: false,
      groupNameTimeError: '',
      groupEndTimeError: null
    };
    this.onCloseGochiConfirm = this.onCloseGochiConfirm.bind(this);
    this.generateRandomString = this.generateRandomString.bind(this);
    this.onSubmitConfirm = this.onSubmitConfirm.bind(this);
    this.checkAccessScreen = this.checkAccessScreen.bind(this);
    this.getDataDidMount = this.getDataDidMount.bind(this);
    this.closeWindowScanQRUser = this.closeWindowScanQRUser.bind(this);
    this.handleSubmitConfirm = this.handleSubmitConfirm.bind(this);
  }

  generateRandomString(length = 32) {
    var text = "";
    var possible =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (var i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    this.setState({
      crfsToken: text,
    });
    console.log("crfs token", text);
    return text;
  }

  onCloseGochiConfirm() {
    this.props.onCloseGochiStaff();
    this.setState({
      showGochiUseConfirm: false,
    });
  }

  checkAccessScreen = async () => {
      let url = window.location.search;
      let params = queryString.parse(url);
      let menuId = params.menuId;
      let shopId = params.shopId;
      let useAmount = params.useAmount;
      let totalUseAmount = params.totalUseAmount;
      let accessToken = params.accessToken;
      let accessCode = params.accessCode;
      let userKidIds = params.userKidIds;
      let gochiKidGroupId = params.gochiKidGroupId;
      var link = "/login";
      if (!accessToken) {
        if (!this.state.isLoggedIn){
            sessionStorage.setItem('loginCallbackUrl', window.location.pathname);
            return window.location.href = link;
        } else {
            if (this.state.userInfo) {
                if (this.state.userInfo.isLogined === false || this.state.userInfo.isGuest) { 
                    window.history.pushState(null, null, '/login');
                    return <Redirect to={link} />
                }
                this.getDataDidMount(this.state.userInfo, menuId, shopId, useAmount, totalUseAmount, gochiKidGroupId, userKidIds);
            }else{
                window.history.pushState(null, null, '/login');
                return <Redirect to={link} />
            }
        }
      } else {
        if (this.state.isLoggedIn){
          sessionStorage.clear();
          localStorage.clear();
        }
        this.getDataDidMount(this.state.userInfo, menuId, shopId, useAmount, totalUseAmount, gochiKidGroupId, userKidIds, accessToken, accessCode);
      }
  }

  UNSAFE_componentWillMount(){ 
        this.checkAccessScreen();
  }

  async getDataDidMount(userInfo, menuId, shopId, useAmount, totalUseAmount, gochiKidGroupId, userKidIds, accessToken, accessCode) {
    let url = window.location.search;
    let params = queryString.parse(url);
    let isFinished = params.isFinished;
    if (userInfo) {
      if (userInfo.isLogined && !userInfo.isGuest) {
        if (shopId && ((userKidIds && userKidIds.length > 0) || this.state.gochiKidUseCode === 1 || this.state.gochiKidUserLimit) && !isFinished) {
          let response = await this.confirmUseGochiKid(
            shopId,
            menuId,
            useAmount,
            totalUseAmount,
            userKidIds,
            accessToken,
            gochiKidGroupId
          );
          console.log('response', response);
          if (response && response.status === 200) {
            this.setState({
              dataInfo: response.data,
              isAccess: true
            });
            if (response.data.usageType === MENU_USAGE_TYPE.USAGE_TYPE_MENU) {
              this.setState({
                taxRate: response.data.taxRate
              });
            }
          } else {
            if (response.data.code === 'gochi.kid.thank.message.not.found') {
              this.props.showError(
                true,
                "",
                response?.responseData?.errorInfo?.content,
                `利用履歴画面に戻る`,
                accessToken ? `/mypage/kodomo_use/search_shop/${shopId}?accessToken=${accessToken}&accessCode=${accessCode}${gochiKidGroupId ? `&gochiKidGroupId=${gochiKidGroupId}` : ''}` : '/mypage/kodomo_use'
              );
            } else if (response.data.code === 'gochi.kid.survey.not.found') {
              this.props.showError(
                true,
                "",
                response?.responseData?.errorInfo?.content,
                `利用履歴画面に戻る`,
                accessToken ? `/mypage/kodomo_use/search_shop/${shopId}?accessToken=${accessToken}&accessCode=${accessCode}${gochiKidGroupId ? `&gochiKidGroupId=${gochiKidGroupId}` : ''}` : '/mypage/kodomo_use'
              );
            } else if (response.data.code === 'gochi.kid.limit.day' && response?.responseData?.errorInfo?.content === '本日の食堂利用回数を超えました。') {
              const elementContentText = <p><p style={{ color: 'red'}}>利用可能人数を超えているため、決済できませんでした。</p>※利用可能残数をご確認ください。</p>;
              this.setState({
                isShowError: true,
                titleError: '',
                contentError: elementContentText,
                textBtnError: '利用店舗画面に戻る',
                urlError: accessToken ? `/mypage/kodomo_use/search_shop/${shopId}?accessToken=${accessToken}&accessCode=${accessCode}${gochiKidGroupId ? `&gochiKidGroupId=${gochiKidGroupId}` : ''}` : `/mypage/kodomo_use/search_shop${gochiKidGroupId ? `?gochiKidGroupId=${gochiKidGroupId}` : ''}`
              });
            } else if (response.data.code === 'exception.errors.gochikid.receipt.not.approved') {
              const elementContentText = <p style={{ color: 'red'}}>利用履歴に未登録または未承認のレシート利用履歴があります。<br />そのため、現在「こどもごちめし」をご利用いただけません。<br />レシートを登録・承認後にご利用いただけます。</p>;
              this.setState({
                isShowError: true,
                titleError: '',
                contentError: elementContentText,
                textBtnError: 'マイページに戻る',
                urlError: accessToken ? `/mypage/kodomo_use/search_shop/${shopId}?accessToken=${accessToken}&accessCode=${accessCode}${gochiKidGroupId ? `&gochiKidGroupId=${gochiKidGroupId}` : ''}` : `/mypage/kodomo_use/`
              });
            } else if (response.responseData.code === "gochi.kid.group.time.invalid") {
              this.setState({
                showGroupTimeErrorModal: true,
                groupNameTimeError: response?.responseData?.content.gochiKidGroupName,
                groupEndTimeError: response?.responseData?.content.endTime,
                urlError: accessToken ? `/mypage/kodomo_use?shopIdQr=${shopId}&accessToken=${accessToken}&accessCode=${accessCode}` : `/mypage/kodomo_use/`
              });
            } else {
              this.props.showError(
                true,
                "",
                response?.responseData?.errorInfo?.content,
                `利用店舗画面に戻る`,
                accessToken ? `/mypage/kodomo_use/search_shop/${shopId}?accessToken=${accessToken}&accessCode=${accessCode}${gochiKidGroupId ? `&gochiKidGroupId=${gochiKidGroupId}` : ''}` : `/mypage/kodomo_use/search_shop${gochiKidGroupId ? `?gochiKidGroupId=${gochiKidGroupId}` : ''}`
              );
            }
          }
        }
        if (isFinished) {
          let tempShopId = this.state.shopId || this.state.shopIdInFinish || (sessionStorage.getItem("gochiKidUsed") ? JSON.parse(sessionStorage.getItem("gochiKidUsed")).shopId : "");
          let response = await this.getListSponsorGochiKid(accessToken, tempShopId, gochiKidGroupId);
          console.log('response', response);
          if (response && response.status === 200) {
            this.setState({
              listSponsor: response.data
            });
          } else {
            this.props.showError(
              true,
              "",
              response?.responseData?.errorInfo?.content
            );
          }
        }
      }
    }
  }

  async componentDidMount() {
    this.generateRandomString();
    const url = window.location.search;
    let params = queryString.parse(url);
    const gochiUserId = params.gochiUserId;
    const menuId = params.menuId;
    const shopId = params.shopId;
    const useAmount = params.useAmount;
    const totalUseAmount = params.totalUseAmount;
    const userKidIds = params.userKidIds;
    const accessToken = params.accessToken;
    const isFinished = params.isFinished;

    if (shopId) {
      this.setState({
        shopId: shopId,
      });
    }

    if (gochiUserId) {
      this.setState({
        gochiUserId: gochiUserId,
      });
    }

    if (menuId) {
      this.setState({
        menuId: menuId,
      });
    }

    if (useAmount) {
      this.setState({
        useAmount: useAmount,
      });
    }

    if (userKidIds) {
      this.setState({
        userKidIds: !Array.isArray(userKidIds) ? [userKidIds] : userKidIds,
      });
    }

    if (totalUseAmount) {
      this.setState({
        totalUseAmount: totalUseAmount,
      });
    }

    if (accessToken) {
      this.setState({
        accessToken: accessToken,
      });
    }

    if (isFinished) {
      this.setState({
        isFinished: isFinished,
        shopNameInFinish: sessionStorage.getItem("gochiKidUsed") ? JSON.parse(sessionStorage.getItem("gochiKidUsed")).shopName : (this.state.dataInfo.shopName || this.props.shopInfo?.shopName),
        menuNameInFinish: sessionStorage.getItem("gochiKidUsed") ? JSON.parse(sessionStorage.getItem("gochiKidUsed")).menuName : "",
        includedTaxPriceInFinish: sessionStorage.getItem("gochiKidUsed") ? JSON.parse(sessionStorage.getItem("gochiKidUsed")).includedTaxPrice : "",
        numberUseInFinish: sessionStorage.getItem("gochiKidUsed") ? JSON.parse(sessionStorage.getItem("gochiKidUsed")).numberUse : "",
        usedAt: sessionStorage.getItem("gochiKidUsed") ? JSON.parse(sessionStorage.getItem("gochiKidUsed")).usedAt : "",
        shopIdInFinish: sessionStorage.getItem("gochiKidUsed") ? JSON.parse(sessionStorage.getItem("gochiKidUsed")).shopId : "",
        totalUseAmountInFinish: sessionStorage.getItem("gochiKidUsed") ? JSON.parse(sessionStorage.getItem("gochiKidUsed")).totalUseAmount : "",
        imageLogoInFinish: sessionStorage.getItem('gochiKidUsed') ? JSON.parse(sessionStorage.getItem("gochiKidUsed")).imageLogo : null,
        scanCodeInFinish: sessionStorage.getItem('gochiKidUsed') ? JSON.parse(sessionStorage.getItem("gochiKidUsed")).scanCode : null,
        scanCodeTypeInFinish: sessionStorage.getItem('gochiKidUsed') ? JSON.parse(sessionStorage.getItem("gochiKidUsed")).scanCodeType : null,
        codeGochiKidInFinish: sessionStorage.getItem('gochiKidUsed') ? JSON.parse(sessionStorage.getItem("gochiKidUsed")).codeGochiKid : null,
        keyGochiKidInFinish: sessionStorage.getItem('gochiKidUsed') ? JSON.parse(sessionStorage.getItem("gochiKidUsed")).keyGochiKid : null,
        mosburgerImageInFinish: sessionStorage.getItem('gochiKidUsed') ? JSON.parse(sessionStorage.getItem("gochiKidUsed")).mosburgerImage : null,
        gochiKidTwoocaInFinish: sessionStorage.getItem('gochiKidUsed') ? JSON.parse(sessionStorage.getItem("gochiKidUsed")).gochiKidTwooca : null,
        isAccess: true
      });
      if (accessToken) {
        this.setState({
          flowQrUserGochiKidPopupFinish: true
        });
      }
    } else {
      sessionStorage.removeItem("gochiKidUsed");
    }
  }

  async confirmUseGochiKid(shopId, menuId, useAmount, totalUseAmount, userKidIds, accessToken, gochiKidGroupId) {
    try {
      const data = await GochiService.confirmGochiKidGroupSpecial(shopId, menuId, useAmount, totalUseAmount, userKidIds, gochiKidGroupId, accessToken);
      return data;
    } catch (error) {
      log('confirm use gochi kid error');
      this.props.showError(true, this.props.t("There is something wrong"), "");
    }
  }

  async getListSponsorGochiKid(accessToken, shopId, gochiKidGroupId) {
    try {
      let params = {
        shopId
      }
      if (gochiKidGroupId) {
        const data = await GochiService.getSponsorGochiKidGroupSpecial(gochiKidGroupId, accessToken, params);
        return data;
      } else {
        const data = await GochiService.getSponsorGochiKid(accessToken, params);
        return data;
      }
    } catch (error) {
      log('confirm use gochi kid error');
      this.props.showError(true, this.props.t("There is something wrong"), "");
    }
  }

  async onSubmitConfirm() {
    this.setState({
      submitConfirm: true,
    });

    const shopId = this.state.shopId;
    const menuId = this.state.menuId;
    const useAmount = this.state.useAmount;
    const totalUseAmount = this.state.totalUseAmount;
    let userKidIds = this.state.userKidIds;
    const accessToken = this.state.accessToken;
    let url = window.location.search;
    let params = queryString.parse(url);
    let accessCode = params.accessCode;
    let gochiKidGroupId = params.gochiKidGroupId;
    let taxRate = this.state.taxRate;

    if (!Array.isArray(userKidIds)){
      userKidIds = [userKidIds];
    }

    try {
      this.props.showLoading(true); 
      let response = null;
      response = await GochiService.useGochiKidGroupSpecial(
        {
          shopId,
          menuId,
          useAmount,
          totalUseAmount,
          userKidIds,
          gochiKidGroupId,
          taxRate
        },
        this.state.crfsToken,
        accessToken
      );
      this.props.showLoading(false);

      if (response.status !== 200) {
        if (response.data) {
          if (response.data.code === "exception.errors.security.has.csrf.token") {
            this.generateRandomString();
            this.props.showError(
              true,
              "",
              this.props.t("other.Please wait for a while as it is being processed")
            );
          }
          if (response.data.code === "gochi.kid.only.poor.use") {
            this.props.showError(
              true,
              "",
              response?.responseData?.errorInfo?.content,
              `利用店舗画面に戻る`,
              accessToken ? `/mypage/kodomo_use/search_shop/${shopId}?accessToken=${accessToken}&accessCode=${accessCode}${gochiKidGroupId ? `&gochiKidGroupId=${gochiKidGroupId}` : ''}` 
                : `/mypage/kodomo_use/search_shop${gochiKidGroupId ? `?gochiKidGroupId=${gochiKidGroupId}` : ''}`
            );
          } else if (response.data.code === "exception.errors.external.coupon.exception") {
            this.props.showError(
              true,
              "",
              "クーポンコードが取得できませんでした。サポートセンターまで問合せください"
            );
          } else if (response.data.code === 'exception.errors.gochikid.receipt.not.approved') {
            const elementContentText = <p style={{ color: 'red'}}>利用履歴に未登録または未承認のレシート利用履歴があります。<br />そのため、現在「こどもごちめし」をご利用いただけません。<br />レシートを登録・承認後にご利用いただけます。</p>;
            this.setState({
              isShowError: true,
              titleError: '',
              contentError: elementContentText,
              textBtnError: 'マイページに戻る',
              urlError: accessToken ? `/mypage/kodomo_use/search_shop/${shopId}?accessToken=${accessToken}&accessCode=${accessCode}${gochiKidGroupId ? `&gochiKidGroupId=${gochiKidGroupId}` : ''}` : `/mypage/kodomo_use/`
            });
          } else if (response.data.content) {
            this.props.showError(
              true,
              "",
              response.data.content
            );
          } else if (response.responseData.code === "gochi.kid.group.time.invalid") {
            this.setState({
              showGroupTimeErrorModal: true,
              groupNameTimeError: response?.responseData?.content.gochiKidGroupName,
              groupEndTimeError: response?.responseData?.content.endTime,
              urlError: accessToken ? `/mypage/kodomo_use?shopIdQr=${shopId}&accessToken=${accessToken}&accessCode=${accessCode}` : `/mypage/kodomo_use/`
            });
          } else {
            this.props.showError(true, this.props.t("other.Unexpected error"), "");
          }
        }
        else 
        this.props.showError(true, this.props.t("other.Unexpected error"), "");
      } else {
        this.setState({
          isFinished: true,
          usedAt: response.data.usedAt,
          shopNameInFinish: this.state.dataInfo.shopName || this.props.shopInfo?.shopName,
          menuNameInFinish: this.state.dataInfo.menuName,
          includedTaxPriceInFinish: this.state.dataInfo.includedTaxPrice,
          numberUseInFinish: !this.state.gochiKidUseCode && !this.state.gochiKidUserLimit ? this.state.userKidIds.length : 1,
          shopIdInFinish: shopId,
          imageLogoInFinish: response.data.imageLogo,
          scanCodeInFinish: response.data.scanCode,
          mosburgerImageInFinish: response.data.mosburgerImage,
          scanCodeTypeInFinish: response.data.scanCodeType,
          codeGochiKidInFinish: response.data.code,
          keyGochiKidInFinish: response.data.key,
          gochiKidTwoocaInFinish: response.data.gochiKidTwooca,
        });
        const paramUsed = {
          includedTaxPrice: this.state.dataInfo.includedTaxPrice ? this.state.dataInfo.includedTaxPrice : 0,
          menuName: this.state.dataInfo.menuName,
          shopName: this.state.dataInfo.shopName || this.props.shopInfo?.shopName,
          numberUse: (!this.state.gochiKidUseCode && !this.state.gochiKidUserLimit ? this.state.userKidIds.length : 1) || 0,
          usedAt: response.data.usedAt,
          shopId: shopId,
          imageLogo: response.data.imageLogo,
          scanCode: response.data.scanCode,
          scanCodeType: response.data.scanCodeType,
          codeGochiKid: response.data.code,
          keyGochiKid: response.data.key,
          mosburgerImage: response.data.mosburgerImage,
          gochiKidTwooca: response.data.gochiKidTwooca,
        };
        paramUsed.totalUseAmount = this.state.totalUseAmount
          ? paramUsed.includedTaxPrice
          : paramUsed.includedTaxPrice * paramUsed.numberUse;
        const currentUrl  = window.location.href;
        let responseSponsor = await this.getListSponsorGochiKid(accessToken, shopId, gochiKidGroupId);
        if (responseSponsor && responseSponsor.status === 200) {
          this.setState({
            listSponsor: responseSponsor.data
          });
          sessionStorage.setItem('gochiKidUsed', JSON.stringify(paramUsed));
          this.props.history.push({
            pathname: '/kodomo/use',
            search: `${new URL(currentUrl).search}&isFinished=true`
          });
          if (accessToken) {
            this.setState({
              flowQrUserGochiKidPopupFinish: true
            });
          }
        } else {
          this.props.showError(
            true,
            "",
            responseSponsor?.responseData?.errorInfo?.content
          );
        }
      }
    } catch (error) {
      console.log("error in gochi kid use", error);
      if (error.code === "exception.errors.security.has.csrf.token") {
        this.props.showError(
          true,
          this.props.t("other.Please wait for a while as it is being processed"),
          ""
        );
      } else {
        this.props.showError(
          true,
          this.props.t("There is something wrong"),
          ""
        );
      }
    }

    this.setState({ showGochiUseConfirm: false, showGochiKidReceiptModal: false });

    this.setState({
      submitConfirm: false,
    });
  }

  showGochiConfirm() {
    this.setState({ showGochiUseConfirm: true });
  }

  async handleSubmitConfirm() {
    if (this.state.dataInfo.gochiKidReceipt === 1) {
      this.setState({
        showGochiUseConfirm: false,
        showGochiKidReceiptModal: true
      });
    } else {
      await this.onSubmitConfirm();
    }
  }

  closeWindowScanQRUser() {
    window.close();
  }

  render() {
    if (!this.state.isAccess) {
      return (
      <>
        <div className="shop-not-avai text-center">
          <img
            src={NO_IMAGE}
            alt={this.props.t(
              "other.This feast button cannot be used because the store is not open"
            )}
            width="100%"
            className="image-not-available"
          />
        </div>

        {this.state.isShowError && (
          <PopupErrorV2 
            showing={this.state.isShowError}
            hideError={() => this.setState({isShowError: false})}
            title={this.state.titleError}
            content={this.state.contentError}
            gotoUrl={this.state.urlError}
            buttonName={this.state.textBtnError}
          />
        )}

        {this.state.showGroupTimeErrorModal && (
          <GochiKidUseGroupTimeErrorModal
            show={this.state.showGroupTimeErrorModal}
            onCancel={() => this.setState({ showGroupTimeErrorModal: false })}
            groupName={this.state.groupNameTimeError}
            endTime={this.state.groupEndTimeError}
            gotoUrl={this.state.urlError}
          />
        )}
      </>);
    }

    const { t } = this.props;
    const dataInfo = this.state.dataInfo;
    const shopName = this.state.dataInfo.shopName || this.props.shopInfo?.shopName;
    const includedTaxPrice = this.state.dataInfo.includedTaxPrice;
    let totalUseAmount = (this.state.totalUseAmount || this.state.gochiKidUseCode || this.state.gochiKidUserLimit)
      ? includedTaxPrice
      : includedTaxPrice * this.state.userKidIds.length;
    if (this.state.isFinished && this.state.totalUseAmountInFinish) {
      totalUseAmount = this.state.totalUseAmountInFinish;
    }

    return (
      <>
        <div className="content font-gothic clr-000000">
          <Header
            title={this.state.isFinished && this.state.gochiKidTwoocaInFinish === 1 ? "お支払い完了" : t("pages.tome.Use this ticket")}
            isLoggedIn={this.state.isLoggedIn}
            t={t}
            hasBack={true}
            usingFlow={true}
          />
          <div className="input-infor">
            <div className={`fs-22 font-weight-bold text-center ${this.state.gochiKidTwoocaInFinish === 1 ? 'mt-5 mb-3' : 'my-5'}`}>
              {this.state.isFinished ? (this.state.gochiKidTwoocaInFinish === 1 ? 'チャージ受付完了' : 'お支払い完了') : 'ご注文内容の確認'}
            </div>
            {this.state.isFinished && this.state.gochiKidTwoocaInFinish === 1 && (
              <div className="gochi-kid-twooca-warning">
                <div>
                  <i className="icon-warning"/>
                </div>
                <div>
                  <div className="font-weight-bold">反映までにお時間がかかります。</div>
                  チャージ完了まで数分程度かかる場合があります。
                  <br />
                  処理結果（完了または失敗）はメールでお知らせするほか、マイページの利用履歴でもご確認いただけます。
                  <br />
                  万が一、チャージに失敗した場合は、メールにて今後の対応をご案内いたします。
                </div>
              </div>
            )}
            <div className="used-price-box mt-3">
              <div className="top">
                {this.state.isFinished ? this.state.shopNameInFinish : shopName}
              </div>
              <div className="mid mt-3 mb-2">
                <span
                  className={
                    totalUseAmount < 1000000
                      ? 'fs-72 line-height-72'
                      : 'fs-48 line-height-48'
                  }
                >
                  {/* {this.state.isFinished && this.state.includedTaxPriceInFinish ? (this.state.includedTaxPriceInFinish ? (this.state.includedTaxPriceInFinish * this.state.numberUseInFinish).toLocaleString() : '') : (includedTaxPrice ? (includedTaxPrice * this.state.userKidIds.length).toLocaleString() : '')} */}
                  {totalUseAmount ? totalUseAmount.toLocaleString() : ""}
                </span>
                <span className="fs-24 line-height-24 fw-700">円</span>
              </div>
              <Moment
                className="bot"
                interval={1000}
                format="YYYY.MM.DD HH:mm:ss"
                local
              />
            </div>

            <div className="pt-2">
              {this.state.isFinished && this.state.scanCodeInFinish && this.state.scanCodeTypeInFinish === SCAN_CODE_TYPE.BARCODE && !(this.state.accessToken || this.state.accessCode) && (
                <div>
                  <Barcode value={this.state.scanCodeInFinish} options={{ format: 'codabar' }} className="barcode" />
                </div>
              )}

              {this.state.isFinished && this.state.scanCodeInFinish && this.state.scanCodeTypeInFinish === SCAN_CODE_TYPE.QRCODE && !(this.state.accessToken || this.state.accessCode) && (
                <div className="text-center mt-2 mb-3 p-3">
                  <QRCode value={this.state.scanCodeInFinish} renderAs="svg" style={{ width: '164px', height: 'auto' }} />
                </div>
              )}

              {this.state.isFinished && this.state.mosburgerImageInFinish && (
                <div>
                  <img src={this.state.mosburgerImageInFinish} alt="mosburger-menu-image" width="100%"/>
                </div>
              )}

              <div className="mt-2 fs-18 font-weight-bold text-break">
                {this.state.isFinished ? this.state.menuNameInFinish : dataInfo.menuName}
              </div>

              {this.state.totalUseAmount
                ? 
                  <div className="fs-18 font-weight-medium infor-price-gochi-kid">
                    <span className="title">利用人数: </span>
                    <span className="title">{this.state.isFinished ? this.state.numberUseInFinish : this.state.userKidIds.length}</span>
                    <span className="fs-12 yen">人</span>
                    <span className="ml-4 title">合計金額: </span>
                    <span className="title">{totalUseAmount ? totalUseAmount.toLocaleString() : ""}</span>
                    <span className="fs-12 yen">円</span>
                  </div>
                :
                  <div className="fs-18 font-weight-medium infor-price-gochi-kid">
                    <span className="title">単価: </span>
                    <span className="title">
                      {this.state.isFinished && this.state.includedTaxPriceInFinish ? this.state.includedTaxPriceInFinish.toLocaleString() : (includedTaxPrice ? (includedTaxPrice).toLocaleString() : '')}
                    </span>
                    <span className="fs-12 yen">円</span>
                    <span className="ml-4 title">個数: </span>
                    <span className="title">{this.state.isFinished ? this.state.numberUseInFinish : (!this.state.gochiKidUseCode && !this.state.gochiKidUserLimit ? this.state.userKidIds.length : 1)}</span>
                    <span className="fs-12 yen">個</span>
                  </div>
              }
              {this.state.isFinished ? (
                <>
                  {this.state.imageLogoInFinish ? (
                    <div>
                      <div className="text-title-sponsor">
                        このお食事は、下記企業・店舗さまからご支援いただいています
                      </div>
                      <div className="sponsor">
                        <div className="row content">
                          <div className="list-rank-1 col-12">
                            <span className="link-rank-1">
                              <img src={this.state.imageLogoInFinish ? this.state.imageLogoInFinish : NO_IMAGE} alt={this.state.shopNameInFinish} width="100%" className="image-sponsor" />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div>
                      {/*<div className="finished-note">
                        ご利用いただいたメニュー内容については、登録メールアドレス宛に送信いたしましたので、ご確認ください。
                        <br />
                        ※「@gochimeshi.com」のドメインからメールを送信します。
                      </div>*/}
                      {(this.state.listSponsor?.listRank1?.length > 0 || this.state.listSponsor?.listRank2?.length > 0 || this.state.listSponsor?.listRank3?.length > 0) &&(
                        <div className="text-title-sponsor">
                          {this.state.gochiKidGroupId ? "このお支払いは、下記企業・店舗さまからご支援いただいています" : "このお食事は、個人のご寄付や以下の皆さまからご支援いただいています"}
                        </div>
                      )}
                      <div className="sponsor">
                        <div className="row content">
                        {Object.entries(this.state.listSponsor).map(([key, obj]) => {
                          if (key === 'listRank1' && obj.length > 0) {
                            return (
                              obj.map(i => (
                                <div className="list-rank-1 col-12" key={i.gochiKidCompanyFundId}>
                                  <a href={i.pageUrl} target="_blank" className="link-rank-1">
                                    <img src={i.logoImage ? i.logoImage : NO_IMAGE} alt={i.companyName} width="100%" className="image-sponsor" />
                                  </a>
                                </div>
                              ))
                            )
                          }
                        }
                        )}
                        </div>
                      </div>
                      <div className="sponsor">
                        <div className="row content">
                        {Object.entries(this.state.listSponsor).map(([key, obj]) => {
                          if (key === 'listRank2' && obj.length > 0) {
                            return (
                              obj.map(i => (
                                <div className="list-rank-2 col-6" key={i.gochiKidCompanyFundId}>
                                  <a href={i.pageUrl} target="_blank" className="link-rank-2">
                                    <img src={i.logoImage ? i.logoImage : NO_IMAGE} alt={i.companyName} width="100%" className="image-sponsor" />
                                  </a>
                                </div>
                              ))
                            )
                          }
                        }
                        )}
                        </div>
                      </div>
                      <div className="sponsor">
                        <div className="row content">
                        {Object.entries(this.state.listSponsor).map(([key, obj]) => {
                          if (key === 'listRank3' && obj.length > 0) {
                            return (
                              obj.map(i => (
                                <div className="list-rank-3 col-4" key={i.gochiKidCompanyFundId}>
                                  <a href={i.pageUrl} target="_blank" className="link-rank-3">
                                    <img src={i.logoImage ? i.logoImage : NO_IMAGE} alt={i.companyName} width="100%" className="image-sponsor" />
                                  </a>
                                </div>
                              ))
                            )
                          }
                        }
                        )}
                        </div>
                      </div>
                    </div>
                  )}

                  {this.state.gochiKidUseCode === 1 && this.state.codeGochiKidInFinish != null && this.state.keyGochiKidInFinish != null && (
                    <div className="lawson-container">
                      <div className="lawson-code-title">発券コード</div>
                      <div className="lawson-code-text">{this.state.codeGochiKidInFinish}</div>
                      <div className="lawson-code-title">発券キー</div>
                      <div className="lawson-code-text">{this.state.keyGochiKidInFinish}</div>
                      <div className="clr-ec4a56 fs-16 mb-2 fw-700">
                        お買い物券は、こどもごちめしで選択した店舗にて発券・ご利用ください。ご利用後は、必ずレシートをお受け取りください。
                        <br />
                        レシート登録時に、レシート発行した店舗とこどもごちめしで選択した店舗が一致しない場合、次回のご利用ができません。
                      </div>
                      <div className="clr-ec4a56 fs-12">※発券コードと発券キーは、GOCHIアカウントの登録メールアドレスに送信されたメールでもご確認いただけます。</div>
                      <div className="lawson-code-title mt-2">発券期限</div>
                      <div className="lawson-date">2025年4月30日まで</div>
                      <a href="https://www.lawson.co.jp/service/loppi/coupon/" target="_blank" className="lawson-link">クーポンの利用方法｜ローソン</a>
                      <div className="lawson-title">Loppiからのお買物券発券について</div>
                      <div className="fs-16 guide-text">
                        まず、各種キャンペーン等でお買物券発券用の「発券コード」と「発券キー」を入手します。
                        <br />
                        その後、店頭端末のLoppiでお買い物券を発券することができます。
                        <br />
                        <br />
                        「STEP01」
                        <br />
                        お買物券発券用の「発券コード」と「発券キー」を取得
                        <br />
                        <br />
                        「STEP02」
                        <br />
                        ローソン店舗に来店する
                        <br />
                        <br />
                        「STEP03」
                        <br />
                        Loppiトップ画面左の「各種番号をお持ちの方」をタッチし、取得した「発券コード」と「発券キー」を入力
                        <br />
                        <br />
                        「STEP04」
                        <br />
                        商品と一緒にお買物券をレジへお持ちください。
                      </div>
                      <div className="lawson-title">注意事項</div>
                      <ul className="fs-14 pl-4 lawson-note">
                        <li><span className="clr-ec4a56">お客様のご都合による返品、返金はできません。</span></li>
                        <li>
                          <span className="clr-ec4a56">お買物券は再発券できません</span>
                          <span>ので、ご注意ください。</span>
                        </li>
                        <li>使用される直前に発券することをおすすめします。</li>
                        <li>お買物券の有効期限は、Loppiでの発券から7日間です。<br />発券から7日が過ぎた場合は、そのお買物券は無効になります。</li>
                        <li>レジご精算前にご提示ください。ご精算終了後にご提示いただいた場合はご利用できません。</li>
                        <li>合計金額（税込）からの精算となります。</li>
                        <li>お釣りのお返しはできません。</li>
                        <li>セルフレジでのご利用はできません。</li>
                        <li>有効期間外でのご利用はできません。</li>
                        <li>ローソンストア100、その他一部店舗ではご利用いただけません。</li>
                        <li>
                          「発券コード」と「発券キー」はお客様の責任のうえ保管してください。
                          <br />
                          万が一他人に使用された場合でも責任は一切負いかねますので予めご了承願います。
                        </li>
                        <li>発券店舗でのみ有効となります。</li>
                        <li>換金はできません。</li>
                        <li>コピー等の偽造、加工する等の不正行為が行われた場合は無効となります。</li>
                        <li>たばこ、各種乗車券、回数券、各種商品券、各種金券、QUOカード、収納代行、切手、印紙、ハガキ、Loppi取次ぎなど一部サービスには使用できません。</li>
                        <li>MACHI cafe DRINK CARDと併用いただけません。</li>
                      </ul>
                    </div>
                  )}
                </>
              ) : (
                <>
                  {(this.state.dataInfo.usageType === MENU_USAGE_TYPE.USAGE_TYPE_VOUCHER || !this.state.menuId) && (
                    <div className="mt-40">
                      <div className="required-dot mb-3-custome">
                        <div className="dot-red"></div>
                        <div className="dot-text-label fs-16 font-weight-bold">
                          消費税区分
                        </div>
                      </div>
                      <div className="d-flex">
                        <label className="radio-custom">
                          <input
                            type="radio"
                            name="taxRate"
                            value={TAX_RATE.TAX_RATE_10_PERCENT}
                            onChange = {(e) => {
                              this.setState({
                                taxRate: TAX_RATE.TAX_RATE_10_PERCENT
                              });
                            }}
                            checked={this.state.taxRate === TAX_RATE.TAX_RATE_10_PERCENT}
                          />
                          <span className="checkmark"></span>
                          <span className="fs-16">10%対象</span>
                        </label>
                        <label className="radio-custom ml-5">
                          <input
                            type="radio"
                            name="taxRate"
                            value={TAX_RATE.TAX_RATE_8_PERCENT}
                            onChange = {(e) => {
                              this.setState({
                                taxRate: TAX_RATE.TAX_RATE_8_PERCENT
                              });
                            }}
                            checked={this.state.taxRate === TAX_RATE.TAX_RATE_8_PERCENT}
                          />
                          <span className="checkmark"></span>
                          <span className="fs-16">8%対象</span>
                        </label>
                      </div>
                    </div>
                  )}
                  <div className="mt-5 clr-F44A4A font-weight-bold">
                    ※オーダー確認ボタンはお店の方の指示に従うか、お客様ご自身でタップしてください。
                  </div>
                </>
              )}
            </div>
            {this.state.isFinished ? (
              <a
                className="btn border-btn-green mt-3 mb-3"
                href="/mypage/kodomo_use"
              >マイページに戻る</a>
            ) : (
            <>
              <div
                className="btn btn-use-55 bg-red mt-3"
                onClick={() => this.showGochiConfirm(dataInfo)}
              >オーダー確認</div>
              <div
                className="btn border-btn mt-3"
                onClick={() => this.props.history.goBack()}
              >戻る</div>
              <div className="gochi-stamp-combo mt-4">
                <div className="gochi-stamp-combo-info border-radius-0 text-left">
                  <div>
                    <div className="fs-12 text-red">ご予約に関しては、直接店舗様へご連絡をお願いいたします。</div>
                    <div><span className="fs-12 clr-000000">チケット利用・よくあるご質問について : </span><a href="https://support.gochimeshi.com/s/" target="_blank" className="fs-12 text-decoration-underline">https://support.gochimeshi.com/s/</a></div>
                  </div>
                </div>
              </div>
            </>
            )}
          </div>
        </div>

        {this.state.showGochiUseConfirm && (
          <GochiKidUseConfirmModal
            show={this.state.showGochiUseConfirm} 
            onCancel={() => this.setState({ showGochiUseConfirm: false })}
            disabledSubmitButton={this.state.submitConfirm}
            shopName={shopName}
            includedTaxPrice={totalUseAmount}
            onSubmit={this.handleSubmitConfirm}
          />
        )}
        {this.state.flowQrUserGochiKidPopupFinish && (
          <Modal show={this.state.flowQrUserGochiKidPopupFinish} className="modal-error-gochi-charge" centered> 
            <div className="modal-body"> 
              <Button variant="secondary" className="close" onClick={() => {this.setState({flowQrUserGochiKidPopupFinish: false})}}>&times;</Button>
    
              <div className="input-infor">
                <div >
                  <h5 className="space-pre-line title-error-gochi-charge">メニューの消し込みが完了しました。「管理画面に戻る」をタップしGOCHIプラットフォーム管理システムに戻ります。</h5>
                  <button className="btn btn-green-38 w-240 m-auto mt-3 btn-error-gochi-charge" onClick={() => this.closeWindowScanQRUser()}>
                    管理画面に戻る
                  </button>
                </div>
              </div>
            </div> 
          </Modal>
        )}

        {this.state.isShowError && (
          <PopupErrorV2 
            showing={this.state.isShowError}
            onHide={() => this.setState({isShowError: false})}
            title={this.state.titleError}
            content={this.state.contentError}
            gotoUrl={this.state.urlError}
            buttonName={this.state.textBtnError}
          />
        )}

        {this.state.showGochiKidReceiptModal && (
          <GochiKidUseReceiptConfirmModal
            show={this.state.showGochiKidReceiptModal} 
            onCancel={() => this.setState({ showGochiKidReceiptModal: false })}
            disabledSubmitButton={this.state.submitConfirm}
            shopName={shopName}
            includedTaxPrice={totalUseAmount}
            onSubmit={this.onSubmitConfirm}
          />
        )}

        {this.state.showGroupTimeErrorModal && (
          <GochiKidUseGroupTimeErrorModal
            show={this.state.showGroupTimeErrorModal}
            onCancel={() => this.setState({ showGroupTimeErrorModal: false })}
            groupName={this.state.groupNameTimeError}
            endTime={this.state.groupEndTimeError}
            gotoUrl={this.state.urlError}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  ...state,
});

const mapDispatchToProps = (dispatch) => ({
  showLoading: (showing) => dispatch(showLoading(showing)),
  showError: (showing, title, content, buttonName, gotoUrl) =>
    dispatch(showError(showing, title, content, buttonName, gotoUrl)),
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(GochiKidUse))
);
